export const firstLetterToLowerCase = (string) => `${string.charAt(0).toLowerCase()}${string.slice(1)}`;
export const firstLetterToUpperCase = (string) => `${string.charAt(0).toUpperCase()}${string.slice(1)}`;